import isEmpty from "lodash/isEmpty";

export const kFormatter = (num) => {
  return Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
    : Math.sign(num) * Math.abs(num);
};
export const getMonths = (month, short) => {
  // Create month names
  const format = short ? "short" : "long";
  const monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (mon) {
    return new Date(2000, mon).toLocaleString({}, { month: format });
  });

  // Return month name (or all of them)
  if (month) {
    return monthNames[month - 1];
  }
  return monthNames;
};

export const addCountry = (values) => {
  if (!isEmpty(values.country)) {
    values.country = values.country.value;
  }
  return values;
};

export const addSupportType = (values) => {
  if (!isEmpty(values.supportType)) {
    values.supportType = values.supportType.name;
  }
  return values;
};

export const addErrorType = (values) => {
  if (!isEmpty(values.errorType)) {
    values.errorType = values.errorType.name;
  }
  return values;
};

export const addPriority = (values) => {
  if (!isEmpty(values.priority)) {
    values.priority = values.priority.name;
  }
  return values;
};

export const addAdminEmails = (values) => {
  const admin_emails = [];
  if (!isEmpty(values.adminA)) {
    admin_emails.push(values.adminA);
    values["admin_emails"] = admin_emails;
    delete values.adminA;
  }
  if (!isEmpty(values.adminB)) {
    admin_emails.push(values.adminB);
    values["admin_emails"] = admin_emails;
    delete values.adminB;
  }
  return values;
};
